import script from "./FormEmailInput.vue?vue&type=script&setup=true&lang=js"
export * from "./FormEmailInput.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__